import { API_BASE_URL, ADMIN_SECRET } from '../utils/constants';

// GET all hero slides
export const fetchHeroSlides = async () => {
  const res = await fetch(`${API_BASE_URL}/api/hero-slides`);
  if (!res.ok) throw new Error('Failed to fetch hero slides');
  return res.json();
};

// POST new hero slide
export const createHeroSlide = async (formData) => {
  const res = await fetch(`${API_BASE_URL}/api/hero-slides`, {
    method: 'POST',
    headers: {
      'admin-secret': `${ADMIN_SECRET}`, // ✅ required
    },
    body: formData
  });
  if (!res.ok) throw new Error('Failed to create hero slide');
  return res.json();
};

// PUT update slide
export const updateHeroSlide = async (id, formData) => {
  const res = await fetch(`${API_BASE_URL}/api/hero-slides/${id}`, {
    method: 'PUT',
    headers: {
      'admin-secret': `${ADMIN_SECRET}`, // ✅ required
    },
    body: formData
  });
  if (!res.ok) throw new Error('Failed to update hero slide');
  return res.json();
};

// DELETE slide
export const deleteHeroSlide = async (id) => {
  const res = await fetch(`${API_BASE_URL}/api/hero-slides/${id}`, {
    method: 'DELETE',
    headers: {
      'admin-secret': `${ADMIN_SECRET}`, // ✅ required
    },
  });
  if (!res.ok) throw new Error('Failed to delete hero slide');
};
